import { withAPIAccount } from '../../lib/http/api';
import { parsedResponse } from '../../lib/http/http';
import { AccountType } from '../../model';
import { API_PREFIX } from '../config';
import {
  IServiceModelListItem,
  ICalculateBody,
  ICalculateRes,
} from '../../model/api-modules/price-calculator';

// 用于判断是否支持测算，屏蔽无用字段
export const getServiceModel = () =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${API_PREFIX}/service-fee/model`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<{ list: IServiceModelListItem[] }>(
        response,
        'data'
      );
      return res;
    } catch (error) {
      return false;
    }
  });

export const getCalculateResult = (body: ICalculateBody) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${API_PREFIX}/service-fee/compute`;
      const response = await api.commonRequest('POST', url, body);
      const res = await parsedResponse<ICalculateRes>(response, 'data');
      return res;
    } catch (error) {
      return false;
    }
  });
